"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _constant = require("../../../../constant");
var _utils = require("../../../../utils");
var _blockEdit = _interopRequireDefault(require("../../../block-edit"));
var _styled = require("../../../base/styled");
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SchoolItem = function SchoolItem(_ref) {
  var student = _ref.student,
    onClickEdit = _ref.onClickEdit,
    isEdit = _ref.isEdit,
    showPrivate = _ref.showPrivate;
  var concentrations = (0, _lodash.compact)([student.firstConcentration, student.secondConcentration]);
  var otherDegreeName = student.otherFirstDegree || student.firstDegreeName;
  var majorName = (0, _utils.getMajorName)(student);
  var minorName = (0, _utils.getMinorNames)(student);
  var collegeTitle = (0, _utils.getCollegeTitle)(student);
  var getMinorTitle = function getMinorTitle() {
    if (!minorName) {
      return 'Minor';
    }
    return student.minors.length > 1 ? 'Minors:' : 'Minor:';
  };
  var getConcentrationTitle = function getConcentrationTitle() {
    if ((0, _lodash.isEmpty)(concentrations)) {
      return 'Concentration';
    }
    return (0, _lodash.size)(concentrations) > 1 ? 'Concentrations' : 'Concentration';
  };
  var getShowGpa = function getShowGpa() {
    if (!isEdit && (!student.gpa || !(student.includeGPAOnResume || showPrivate)) && (!student.firstMajorGPA || !(student.includeFirstMajorGPAOnResume || showPrivate)) && (!student.secondMajorGPA || !(student.includeSecondMajorGPAOnResume || showPrivate)) && (!student.thirdMajorGPA || !(student.includeThirdMajorGPAOnResume || showPrivate))) {
      return false;
    }
    return !(student.gpa && (!student.includeGPAOnResume || showPrivate) && student.firstMajorGPA && (!student.includeFirstMajorGPAOnResume || showPrivate) && student.secondMajorGPA && (!student.includeSecondMajorGPAOnResume || showPrivate) && student.thirdMajorGPA && (!student.includeThirdMajorGPAOnResume || showPrivate));
  };
  var getShowHighSchool = function getShowHighSchool() {
    return !(!isEdit && (!student.highSchoolName || !student.includeHighSchoolOnResume));
  };
  var hasScholarships = (0, _lodash.isBoolean)(student.hasScholarships) ? student.hasScholarships : (0, _lodash.parseInt)(student.hasScholarships);
  var deletePeriod = function deletePeriod(text) {
    var _useState = (0, _react.useState)(text),
      _useState2 = _slicedToArray(_useState, 2),
      textWithoutPeriod = _useState2[0],
      setTextWithoutPeriod = _useState2[1];
    var lastCharacter = textWithoutPeriod.charAt(textWithoutPeriod.length - 1);
    while (lastCharacter === '.') {
      var newText = textWithoutPeriod.slice(0, -1);
      setTextWithoutPeriod(newText);
      lastCharacter = newText.charAt(textWithoutPeriod.length - 1);
    }
    return textWithoutPeriod;
  };
  var getShowProfileItem = function getShowProfileItem(items, conditions) {
    var includesOnResume = items.map(function (attrib) {
      return attrib.includeOnResume;
    }).filter(function (include) {
      return include === 1 || include === true;
    });
    if (!(0, _lodash.isEmpty)(items) && includesOnResume.length === 0 && conditions) {
      return showPrivate;
    }
    return !((0, _lodash.isEmpty)(items) || includesOnResume.length === 0);
  };
  var getPrivateText = function getPrivateText(attrib) {
    return attrib ? '' : ' (Private)';
  };
  var getHighSchoolText = function getHighSchoolText() {
    var cityName = student.internationalHighSchool ? student.highSchoolCountryCity : student.highSchoolCityName;
    var stateName = student.internationalHighSchool ? student.highSchoolCountryName : student.highSchoolStateName;
    var textPrivate = getPrivateText(student.includeHighSchoolOnResume);
    return "".concat(cityName, ", ").concat(stateName, " | Class of ").concat(student.highSchoolYearGraduation, " ").concat(textPrivate);
  };
  var majorStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '3px'
  };
  var majorGPAStyle = {
    marginLeft: '3px',
    marginBottom: '0px',
    lineHeight: '120%'
  };
  return /*#__PURE__*/_react.default.createElement(_styled2.Container, null, /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_ACADEMICS);
    },
    title: "University",
    color: "#2F1747",
    isEdit: isEdit,
    show: student.universityName || student.cityOfUniversityName && student.stateOfUniversity
  }, /*#__PURE__*/_react.default.createElement(_styled2.Text, null, student.universityName), student.cityOfUniversityName && student.stateOfUniversity && /*#__PURE__*/_react.default.createElement(_styled2.TextSmall, null, "".concat(student.cityOfUniversityName, ", ").concat(student.stateOfUniversity))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_ACADEMICS);
    },
    title: "Degree & Academic Info",
    color: "#2F1747",
    isEdit: isEdit,
    show: majorName || otherDegreeName || student.firstCollege || student.secondDegreeName && student.otherSecondDegree || student.secondCollege
  }, majorName && /*#__PURE__*/_react.default.createElement(_styled2.Text, null, majorName), otherDegreeName && /*#__PURE__*/_react.default.createElement(_styled2.Text, null, otherDegreeName), student.firstCollege && /*#__PURE__*/_react.default.createElement(_styled2.TextSmall, null, student.firstCollege), (student.secondDegreeName || student.otherSecondDegree) && /*#__PURE__*/_react.default.createElement(_styled2.Text, null, student.otherSecondDegree || student.secondDegreeName), student.secondCollege && /*#__PURE__*/_react.default.createElement(_styled2.TextSmall, null, student.secondCollege), /*#__PURE__*/_react.default.createElement(_styled2.Text, null, student && "".concat(student.typeName, " | Class of ").concat(student.yearGraduation))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_ACADEMICS);
    },
    title: getMinorTitle(),
    color: "#2F1747",
    noBlock: true,
    isEdit: isEdit,
    show: minorName
  }, minorName && /*#__PURE__*/_react.default.createElement(_styled2.Text, null, minorName)), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_ACADEMICS);
    },
    title: getConcentrationTitle(),
    color: "#2F1747",
    noBlock: true,
    isEdit: isEdit,
    show: showPrivate || (0, _lodash.parseInt)(student.hasConcentrations) === 1 && (0, _lodash.size)(concentrations) > 0
  }, /*#__PURE__*/_react.default.createElement(_styled2.Text, null, (0, _lodash.join)(concentrations, ', '))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_COLLEGIATE_ATHLETICS);
    },
    title: collegeTitle,
    color: "#2F1747",
    isEdit: isEdit,
    show: getShowProfileItem(student.d1Athletics)
  }, student.d1Athletics.map(function (athletic) {
    return /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
      key: athletic.id,
      $bsStyle: {
        marginBottom: '5px'
      },
      show: athletic.includeOnResume || showPrivate
    }, /*#__PURE__*/_react.default.createElement(_styled2.Text, {
      italic: true
    }, "".concat(athletic.universityName, " ").concat(getPrivateText(athletic.includeOnResume))), /*#__PURE__*/_react.default.createElement(_styled2.Text, null, athletic.sportName), /*#__PURE__*/_react.default.createElement(_styled2.TextSmall, null, "".concat(deletePeriod(athletic.position), " | ").concat(athletic.startYear, "-").concat(athletic.endPeriodName === 'Present' ? 'Present' : athletic.endYear)));
  })), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_ACADEMICS);
    },
    title: "",
    color: "#2F1747",
    noBlock: true,
    isEdit: isEdit,
    show: getShowGpa()
  }, /*#__PURE__*/_react.default.createElement(_styled2.TitleTextBlock, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, student.gpa ? 'GPA: ' : 'GPA'), student.gpa && (!student.includeGPAOnResume ? showPrivate : true) && /*#__PURE__*/_react.default.createElement(_styled2.Text, {
    title: "Not included on my profile",
    $bsStyle: {
      marginLeft: '3px'
    }
  }, "".concat(student.gpa).concat(getPrivateText(student.includeGPAOnResume)))), student.firstMajorGPA && /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
    show: student.includeFirstMajorGPAOnResume || showPrivate
  }, /*#__PURE__*/_react.default.createElement(_styled2.TitleTextBlock, {
    $bsStyle: majorStyle
  }, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "".concat(student.otherFirstMajor ? (0, _lodash.capitalize)(student.otherFirstMajor) : student.firstMajorName, " \n              GPA: ")), student.firstMajorGPA && /*#__PURE__*/_react.default.createElement(_styled2.Text, {
    $bsStyle: majorGPAStyle
  }, "".concat(student.firstMajorGPA).concat(getPrivateText(student.includeFirstMajorGPAOnResume))))), student.secondMajorGPA && (student.specialization === '4' || student.specialization === '2' || student.specialization === '3') && /*#__PURE__*/_react.default.createElement(_styled2.TitleTextBlock, {
    $bsStyle: majorStyle
  }, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "".concat(student.otherSecondMajor ? (0, _lodash.capitalize)(student.otherSecondMajor) : student.secondMajorName, " \n                  GPA: ")), student.secondMajorGPA && /*#__PURE__*/_react.default.createElement(_styled2.Text, {
    title: "Not included on my profile",
    $bsStyle: majorGPAStyle
  }, "".concat(student.secondMajorGPA).concat(getPrivateText(student.includeSecondMajorGPAOnResume)))), student.thirdMajorGPA && student.specialization === '3' && /*#__PURE__*/_react.default.createElement(_styled2.TitleTextBlock, {
    $bsStyle: majorStyle
  }, /*#__PURE__*/_react.default.createElement(_styled2.Title, {
    $bsStyle: {
      marginRight: '3px'
    }
  }, "".concat(student.otherThirdMajor ? (0, _lodash.capitalize)(student.otherThirdMajor) : student.thirdMajorName, " \n                GPA: ")), /*#__PURE__*/_react.default.createElement(_styled2.Text, {
    title: "Not included on my profile",
    $bsStyle: majorGPAStyle
  }, "".concat(student.thirdMajorGPA).concat(getPrivateText(student.includeThirdMajorGPAOnResume))))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_ACADEMICS);
    },
    title: "Honors",
    color: "#2F1747",
    isEdit: isEdit,
    show: getShowProfileItem(student.honors)
  }, (0, _lodash.parseInt)(student.hasHonors) === 1 && /*#__PURE__*/_react.default.createElement(_styled.List, null, (0, _lodash.map)((0, _lodash.orderBy)(student.honors, 'year', 'desc'), function (honor) {
    return /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
      key: honor.isThroughoutCollege ? honor.name : "".concat(honor.year, "-").concat(honor.name),
      show: honor.includeOnResume || showPrivate,
      variant: "li"
    }, honor.name, !(0, _lodash.isEmpty)(honor.year) && !honor.isThroughoutCollege && " (".concat((0, _lodash.join)((0, _lodash.isArray)(honor.year) ? honor.year : [honor.year], ', '), ") "), getPrivateText(honor.includeOnResume));
  }))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_ACADEMICS);
    },
    title: "Scholarships ".concat(getPrivateText(hasScholarships)),
    color: "#2F1747",
    isEdit: isEdit,
    show: getShowProfileItem(student.scholarships)
  }, /*#__PURE__*/_react.default.createElement(_styled.List, null, student.scholarships.map(function (scholarship) {
    return /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
      key: "".concat(scholarship.amount, "-").concat(scholarship.name),
      show: scholarship.includeOnResume || showPrivate,
      variant: "li"
    }, "".concat(scholarship.name, " ").concat(scholarship.amount || scholarship.fullTuition ? "(".concat(!scholarship.fullTuition ? (0, _utils.formatMoney)(scholarship.amount) : 'Full Tuition', ") ").concat(scholarship.includeOnResume ? '' : '(Private)') : ''));
  }))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_COURSEWORK);
    },
    title: "Relevant Coursework",
    color: "#2F1747",
    isEdit: isEdit,
    show: getShowProfileItem(student.coursework)
  }, /*#__PURE__*/_react.default.createElement(_styled.List, null, student.coursework.map(function (course) {
    return /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
      key: "".concat(course.id, "-").concat(course.course),
      show: course.includeOnResume || showPrivate,
      variant: "li"
    }, course.course, (0, _utils.getMajor)(course), getPrivateText(course.includeOnResume));
  }))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_RESEARCH_AND_PROGRAMS);
    },
    title: "Research & Academic Projects ",
    color: "#2F1747",
    isEdit: isEdit,
    show: getShowProfileItem(student.enhancedAcademicExperiences)
  }, (0, _lodash.orderBy)(student.enhancedAcademicExperiences, ['isThroughoutCollege', 'year', 'period'], ['desc', 'desc', 'desc']).map(function (experience) {
    var experienceCountryCity = experience.countryCity ? "".concat(experience.countryCity, " | ") : '';
    var experienceCityName = experience.cityName ? "".concat(experience.cityName, " | ") : '';
    var experienceInternational = experience.international ? experienceCountryCity : experienceCityName;
    var experienceCountryName = experience.countryName ? "".concat(experience.countryName, " | ") : '';
    var experienceState = experience.state ? "".concat(experience.state, " | ") : '';
    return /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
      key: experience.id,
      $bsStyle: {
        marginBottom: '5px'
      },
      show: experience.includeOnResume || showPrivate
    }, /*#__PURE__*/_react.default.createElement(_styled2.Text, {
      italic: true
    }, "".concat(deletePeriod(experience.program), " ").concat(getPrivateText(experience.includeOnResume))), /*#__PURE__*/_react.default.createElement(_styled2.TextSmall, null, ((experience === null || experience === void 0 ? void 0 : experience.remote) === 1 ? 'Remote' : experienceInternational, experience.international ? experienceCountryName : experienceState), "".concat(experience.isThroughoutCollege ? 'Throughout College' : experience.periodOfStudyName, "\n                ").concat(experience.isThroughoutCollege ? '' : experience.year)));
  })), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_STUDY_ABROAD);
    },
    title: "Study Abroad",
    color: "#2F1747",
    isEdit: isEdit,
    show: getShowProfileItem(student.studiesAbroad)
  }, student.studiesAbroad.map(function (study) {
    return /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
      key: study.name,
      $bsStyle: {
        marginBottom: '5px'
      },
      show: study.includeOnResume || showPrivate
    }, /*#__PURE__*/_react.default.createElement(_styled2.Text, {
      italic: true
    }, "".concat(study.name, " ").concat(getPrivateText(study.includeOnResume))), /*#__PURE__*/_react.default.createElement(_styled2.Text, null, "".concat((study === null || study === void 0 ? void 0 : study.international) === 1 ? "".concat(study.countryCity, ", ").concat(study.countryName) : "".concat(study.cityName, ", ").concat(study.stateName), " | ").concat(study.year)));
  })), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_HIGH_SCHOOL, true);
    },
    title: "High School",
    color: "#2F1747",
    isEdit: isEdit,
    show: getShowHighSchool()
  }, student.highSchoolName && /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
    show: student.includeHighSchoolOnResume || showPrivate
  }, /*#__PURE__*/_react.default.createElement(_styled2.Text, null, student.highSchoolName || ''), /*#__PURE__*/_react.default.createElement(_styled2.Text, null, getHighSchoolText()), /*#__PURE__*/_react.default.createElement("ul", {
    style: {
      paddingLeft: '15px'
    }
  }, /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
    show: student.includeActSatScoreOnResume || showPrivate
  }, /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
    show: student.actScore,
    variant: "li"
  }, "ACT: ", student.actScore, " ", getPrivateText(student.includeActSatScoreOnResume)), /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
    show: student.satScore,
    variant: "li"
  }, "SAT: ", student.satScore, " ", getPrivateText(student.includeActSatScoreOnResume))), getShowProfileItem(student.highSchoolHonors) && student.highSchoolHonors.map(function (honor) {
    return /*#__PURE__*/_react.default.createElement(_styled2.ValidateItem, {
      key: "".concat(honor.name, " ").concat(honor.year),
      show: honor.includeOnResume || showPrivate,
      variant: "li"
    }, "".concat(honor.name, " (").concat(honor.year, ") ").concat(getPrivateText(honor.includeOnResume)));
  })))));
};
SchoolItem.propTypes = {
  student: _utils.studentProps.isRequired,
  onClickEdit: _propTypes.default.func.isRequired,
  isEdit: _propTypes.default.bool.isRequired,
  showPrivate: _propTypes.default.bool.isRequired
};
var _default = SchoolItem;
exports.default = _default;